export function shareButton() {
  $(document).on('click', '.js-share-facebook', function() {
    const $url = window.location.href;
    const $encodeUrl = encodeURIComponent($url);
    const $href = 'https://www.facebook.com/sharer/sharer.php?u=' + $encodeUrl;
    window.open($href, 'FBwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes');
    return false;
  });
  $(document).on('click', '.js-share-twitter', function() {
    const $url = window.location.href;
    const $title = encodeURIComponent($('head').find('title').text());
    const $encodeUrl = encodeURIComponent($url);
    const $href = 'http://twitter.com/intent/tweet?text=' + $title + '&amp;url=' + $encodeUrl;
    window.open($href, 'TWwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes');
    return false;
  });
  return $(document).on('click', '.js-share-line', function() {
    const $url = window.location.href;
    const $title = encodeURIComponent($('head').find('title').text());
    const $encodeUrl = encodeURIComponent($url);
    const $href = 'http://line.me/R/msg/text/?' + $title + ' ' + $encodeUrl;
    window.open($href, 'LINEwindow', 'width=650, height=750, menubar=no, toolbar=no, scrollbars=yes');
    return false;
  });
}